export default "__VITE_ASSET__hLuveU4j__"